import { Box, IconButton, Typography, Button, useMediaQuery, useTheme, Dialog, DialogTitle, DialogContent } from '@mui/material';
import React, { useState } from 'react';


const Calculator = () => {
  const [input, setInput] = useState('');
  const [result, setResult] = useState('');

  const handleButtonClick = (value) => {
    if (value === '=') {
      try {
        setResult(eval(input).toString());
      } catch (error) {
        setResult('Error');
      }
    } else if (value === 'C') {
      setInput('');
      setResult('');
    } else if (value === '⌫') {
      setInput(input.slice(0, -1));
    } else {
      setInput(input + value);
    }
  };

  const buttons = [
    '7', '8', '9', '/',
    '4', '5', '6', '*',
    '1', '2', '3', '-',
    '0', '.', '=', '+',
    'C', '⌫'
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ 
        p: 2, 
        mb: 2, 
        bgcolor: '#f5f5f5', 
        borderRadius: 1,
        textAlign: 'right',
        minHeight: '60px'
      }}>
        <Typography variant="h6" color="text.secondary">
          {input || '0'}
        </Typography>
        <Typography variant="h5" fontWeight="bold">
          {result || '0'}
        </Typography>
      </Box>
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 1
      }}>
        {buttons.map((btn) => (
          <Button
            key={btn}
            variant="contained"
            onClick={() => handleButtonClick(btn)}
            sx={{
              minWidth: '40px',
              bgcolor: btn === '=' ? '#42A5F5' : '#e0e0e0',
              color: btn === '=' ? 'white' : 'black',
              '&:hover': {
                bgcolor: btn === '=' ? '#1976D2' : '#cfcfcf'
              }
            }}
          >
            {btn}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default Calculator